import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import graphqlClientFactory from 'lib/graphql-client-factory';
import {
  ArticleSearchRecentDocument,
  ArticleSearchRecentQueryVariables,
} from 'lib/services/queries/RecentArticles.graphql';
import { apiHost } from 'api/apiHost';
import { articleService } from 'lib/services/ArticleService';
import { ArticleCardData } from 'model/Article';

const graphQLClient = graphqlClientFactory();

export const articleApi = createApi({
  reducerPath: 'articleAPI',
  baseQuery: fetchBaseQuery({ baseUrl: `${apiHost}/api/funds` }), // should domain-based URL
  endpoints: (build) => ({
    getRecentArticles: build.query({
      queryFn: async (_arg) => {
        const result = await graphQLClient.request<ArticleSearchRecentQueryVariables>(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ArticleSearchRecentDocument as any,
          {
            siteId: _arg.siteId,
            language: _arg.language,
            contentGroupId: _arg.contentGroupId,
            pageSize: 8,
          }
        );
        return {
          data: result?.search.results,
        };
      },
    }),
    getArticlesWithTheme: build.query<
      { articles: ArticleCardData[]; total: number },
      { language: string; siteId: string; themeId: string; pageSize: number; pageNumber?: number }
    >({
      queryFn: async ({ language, siteId, themeId, pageSize, pageNumber = 1 }) => {
        return {
          data: await articleService.getFeaturedThemeArticles(
            language,
            siteId,
            themeId,
            pageSize,
            pageNumber
          ),
        };
      },
    }),
  }),
});

export const { useLazyGetRecentArticlesQuery, useGetArticlesWithThemeQuery } = articleApi;
